let Language = function () {
  'ngInject'

  return {
    getAvailableLanguageKeys: getAvailableLanguageKeys,
    getDefaultLanguage: getDefaultLanguage,
  }

  function getAvailableLanguageKeys () {
    return ['IT', 'EN', 'DE', 'FR', 'NL'];
  }

  function getDefaultLanguage () {
    return getAvailableLanguageKeys()[0];
  }

}

export default Language



// WEBPACK FOOTER //
// ./client/app/common/factories/languageFactory/language.factory.js